module.exports = __webpack_public_path__ + "static/media/Habilitacion1.8f965ef0.pdf";